module.exports = __webpack_public_path__ + "img/banner-1.360c8854.jpg";